(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    (() => {
  const pending = [];
  const requests = new Map();
  let active = 0;
  const pump = () => {
    while (active < 3 && pending.length) {
      active += 1;
      const job = pending.shift();
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 8000);
      fetch('/apps/views-count-dev/product', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'same-origin',
        signal: controller.signal,
        body: JSON.stringify({
          storeId: job.card.dataset.viewsStore,
          productId: job.card.dataset.viewsProduct,
          productHandle: job.card.dataset.viewsHandle,
          vcbToken: false,
          preview: true
        })
      }).then(response => response.ok ? response.json() : null)
        .then(job.resolve, () => job.resolve(null))
        .finally(() => {
          clearTimeout(timeout);
          active -= 1;
          pump();
        });
    }
  };
  const load = card => {
    const id = card.dataset.viewsProduct;
    if (!requests.has(id)) {
      requests.set(id, new Promise(resolve => {
        pending.push({ card, resolve });
        pump();
      }));
    }
    requests.get(id).then(data => {
      const meter = card.querySelector('[data-card-views]');
      if (!meter || !data || data.success !== true || !data.settings) return;
      const count = data.settings.viewsType === 'unique' ? data.visitors : data.count;
      if (!Number.isSafeInteger(count) || count <= 0) return;
      const label = data.settings.text;
      const before = data.settings.textBefore;
      if (typeof label !== 'string') return;
      meter.textContent = [typeof before === 'string' ? before : '', String(count), label].filter(Boolean).join(' ');
      meter.style.display = 'block';
      meter.style.visibility = 'visible';
      meter.removeAttribute('aria-hidden');
    });
  };
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        observer.unobserve(entry.target);
        load(entry.target);
      }
    });
  }, { rootMargin: '120px' }) : null;
  const init = root => {
    const cards = [];
    if (root.matches?.('[data-views-product]')) cards.push(root);
    cards.push(...root.querySelectorAll('[data-views-product]'));
    cards.forEach(card => {
      if (card.dataset.viewsReady) return;
      card.dataset.viewsReady = 'true';
      if (observer) observer.observe(card);
      else load(card);
    });
  };
  const start = () => {
    init(document);
    const main = document.getElementById('MainContent');
    if (main) new MutationObserver(changes => {
      changes.forEach(change => change.addedNodes.forEach(node => {
        if (node.nodeType === Node.ELEMENT_NODE) init(node);
      }));
    }).observe(main, { childList: true, subtree: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
  } catch(e) { console.error(e); }
})();

})();
